import React, { createContext, useState, useEffect } from 'react'
import icdCodesService from "../services/icd_codes";
import { extractToken } from '../utils/localStorage';

export const ICDCodesContext = createContext()

export const ICDCodesProvider = ({ children }) => {
  const [icdOptions, setIcdOptions] = useState([]);
  const token = extractToken();
  // console.log("token:", token);

  useEffect(() => {
    if (token?.type === "access") {
 
  
      fetchIcdCodes();
  }

  }, [])

  const fetchIcdCodes = async () => {
    try {

      const response = await icdCodesService.getIcdCodesList();
      setIcdOptions(response?.data?.results?.map(item => ({
        label: `${item.code} - ${item.description}`,
        value: `${item.code} - ${item.description}`,
      })) || []);
    }
    catch(err) {
      
    }
  };
  
  return (
    <ICDCodesContext.Provider value={{ icdOptions, setIcdOptions }}>
      {children}
    </ICDCodesContext.Provider>
  );
};
